/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Folder_Name_Too_LongInputs */



/**
* | output |
* | --- |
* | "Folder name is too long" |
*
* @param {Spaces_Folder_Name_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_name_too_long = /** @type {((inputs?: Spaces_Folder_Name_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Name_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Ordnername ist zu lang")
	return /** @type {LocalizedString} */ ("Folder name is too long")
});